/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { UserCurrentStatus } from "../../Common/User/UserCurrentStatus";

export const protobufPackage = "Reality.Reality.Api";

export interface AgencyEventRankingIndividual {
  vliveId: string;
  rank: number;
  iconUrl: string;
  username: string;
  score: number;
  profileId: string;
  currentStatus?: UserCurrentStatus | undefined;
}

function createBaseAgencyEventRankingIndividual(): AgencyEventRankingIndividual {
  return { vliveId: "", rank: 0, iconUrl: "", username: "", score: 0, profileId: "", currentStatus: undefined };
}

export const AgencyEventRankingIndividual = {
  encode(message: AgencyEventRankingIndividual, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.vliveId !== "") {
      writer.uint32(10).string(message.vliveId);
    }
    if (message.rank !== 0) {
      writer.uint32(16).int64(message.rank);
    }
    if (message.iconUrl !== "") {
      writer.uint32(26).string(message.iconUrl);
    }
    if (message.username !== "") {
      writer.uint32(34).string(message.username);
    }
    if (message.score !== 0) {
      writer.uint32(40).int64(message.score);
    }
    if (message.profileId !== "") {
      writer.uint32(50).string(message.profileId);
    }
    if (message.currentStatus !== undefined) {
      UserCurrentStatus.encode(message.currentStatus, writer.uint32(58).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgencyEventRankingIndividual {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgencyEventRankingIndividual();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.vliveId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.rank = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.iconUrl = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.username = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.score = longToNumber(reader.int64() as Long);
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.profileId = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.currentStatus = UserCurrentStatus.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgencyEventRankingIndividual {
    return {
      vliveId: isSet(object.vliveId) ? globalThis.String(object.vliveId) : "",
      rank: isSet(object.rank) ? globalThis.Number(object.rank) : 0,
      iconUrl: isSet(object.iconUrl) ? globalThis.String(object.iconUrl) : "",
      username: isSet(object.username) ? globalThis.String(object.username) : "",
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
      profileId: isSet(object.profileId) ? globalThis.String(object.profileId) : "",
      currentStatus: isSet(object.currentStatus) ? UserCurrentStatus.fromJSON(object.currentStatus) : undefined,
    };
  },

  toJSON(message: AgencyEventRankingIndividual): unknown {
    const obj: any = {};
    if (message.vliveId !== "") {
      obj.vliveId = message.vliveId;
    }
    if (message.rank !== 0) {
      obj.rank = Math.round(message.rank);
    }
    if (message.iconUrl !== "") {
      obj.iconUrl = message.iconUrl;
    }
    if (message.username !== "") {
      obj.username = message.username;
    }
    if (message.score !== 0) {
      obj.score = Math.round(message.score);
    }
    if (message.profileId !== "") {
      obj.profileId = message.profileId;
    }
    if (message.currentStatus !== undefined) {
      obj.currentStatus = UserCurrentStatus.toJSON(message.currentStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgencyEventRankingIndividual>, I>>(base?: I): AgencyEventRankingIndividual {
    return AgencyEventRankingIndividual.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgencyEventRankingIndividual>, I>>(object: I): AgencyEventRankingIndividual {
    const message = createBaseAgencyEventRankingIndividual();
    message.vliveId = object.vliveId ?? "";
    message.rank = object.rank ?? 0;
    message.iconUrl = object.iconUrl ?? "";
    message.username = object.username ?? "";
    message.score = object.score ?? 0;
    message.profileId = object.profileId ?? "";
    message.currentStatus = (object.currentStatus !== undefined && object.currentStatus !== null)
      ? UserCurrentStatus.fromPartial(object.currentStatus)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
